import { useTranslate } from '@ur-solutions/react-hooks'
import { DropdownDomain } from './types'

export function useDropdownDomainTranslations() {
  return useTranslate({
    dropdownTitle: 'common.dropdown-on-pages',
    activities: 'common.activities',
    terminal: 'common.terminal',
    timeEntries: 'common.time-entries',
    absence: 'common.absence',
    responsibleUser: 'documents.responsible-user',
    issueCategoryResponsible: 'issue.category-responsible-user',
  })
}

export function createDropdownDomains(
  translations: ReturnType<typeof useDropdownDomainTranslations>
): DropdownDomain[] {
  return [
    {
      title: translations.dropdownTitle,
      dropdowns: {
        [translations.activities]: 'activities',
        [translations.terminal]: 'terminal',
        [translations.timeEntries]: 'time_entries',
        [translations.absence]: 'absences',
        [translations.responsibleUser]: 'responsible_user',
        [translations.issueCategoryResponsible]: 'issue_category_responsible',
      },
    },
  ]
}
